import { render, staticRenderFns } from "./CommonTableHead.vue?vue&type=template&id=59af5b95&scoped=true"
import script from "./CommonTableHead.vue?vue&type=script&lang=ts"
export * from "./CommonTableHead.vue?vue&type=script&lang=ts"
import style0 from "./CommonTableHead.vue?vue&type=style&index=0&id=59af5b95&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af5b95",
  null
  
)

export default component.exports